<template>
    <modal class="new-modal-default"  :name="modal_name"  transition="nice-modal-fade" :delay="100"  :width="750" :height="420" :pivot-y="0.5" :adaptive="true" :scrollable="false" style="pointer-events:inherit !important" 
            v-bind:click-to-close="false">
        <div class="v-modal-content" style="background-color: #ffffff !important;">
            <div class="v-modal-header" >
                <span class="v-modal-dialog-title v-modal-title fw-600 py-3 ml-auto mr-auto"
                    style="color: #fff !important;letter-spacing:1px;">Add Product</span>
                <button type="button" class="pointer" style="background-color: #00448b !important;outline:none;"
                    aria-label="Close" @click="hideAddProductModal()">
                    <span aria-hidden="true">
                        <i class="icon icon-close" style="color:white;margin:10px 0px 0 0;"></i>
                    </span>
                </button>
            </div>
            <div class="v-modal-body px-5 ml-2" style="overflow:hidden;">
                <div class="d-flex">
                    <!--Upload Image-->
                    <div style="text-align:center;">
                        <hollow-dots-spinner v-if="img_loader" style="position: absolute;margin: 0;top: 22px;left:65px;display: flex;width: 108% !important;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                        <span style="text-align:center;">
                        <img v-if="product_pic" :src="product_pic" class="contact-image" alt="Product Pic"
                            style="height: 6em; width: 6em; border-radius: 6px;padding:20px;border:1px solid #cdd2da;" />
                        <img v-else :src="imgDataUrl" class="contact-image" alt="Product Pic"
                            style="height: 6em; width: 6em; border-radius: 6px;padding:20px;border:1px solid #cdd2da;" />
                        </span>
                        <upload-picture @CallLoader="CallLoader" @uploadImage="uploadImage"></upload-picture>
                    </div>
                    <div class="form-group w-100 pl-5 pr-6">
                        <!--Starred/Not Starred-->
                        <div class="d-flex align-items-center justify-content-between row mx-0 mt-4">
                            <span class="fs-14 fw-600 text-secondary"  style="top:5px !important">Product Name<sup class="pl-1 fs-14 text-danger">*</sup></span>
                            <span class="float-right">
                                <el-tooltip class="item" effect="dark" :content="starDetails" placement="top">
                                    <input class="star mr-2 fs-20" @change="starData(is_star)"  v-model="is_star" type="checkbox">
                                </el-tooltip>
                            </span>
                        </div>
                        <!--Product Name-->
                        <input class="inputFieldNew mt-3" type="text" maxlength="50" placeholder="Enter Product Name"
                            name="product_name" v-model="product_name" v-validate="'required'" />
                        <div class=" fs-13 ">
                            <span class="input-field-length float-right">{{ product_name.length }}/50</span>
                            <span class="float-left text-danger" v-show="errors.has('product_name')">Product Name is required</span>
                        </div>

                    </div>
                </div>
                <!--Product Description-->
                <div>
                    <h3 class="fs-14 fw-500 text-secondary">Product Description<sup class="pl-1 fs-14 text-danger">*</sup></h3>
                    <div class="inner-div">
                        <textarea-autosize maxlength="150" class="digi-textarea white-background bordered text-width  mt-3"
                            name="product_description" v-model="product_description" v-validate="'required'"
                            placeholder="Enter Product Description" style="height: 6em; overflow: auto;width: 98% !important;" />
                    </div>
                </div>
                <div class="text-right" style="padding-right: 20px;">
                    <span class="input-field-length">{{ product_description.length }}/150</span>
                    <span class="float-left text-danger mb-3" v-show="errors.has('product_description')">Product
                        Description is required
                    </span>
                </div>
            </div>
            <div v-if="disableButtonAndDisplayLoader == false" class="v-modal-footer m-auto p-4">
                <button class="btn new-cancel-button ml-2 mr-2" @click="hideAddProductModal()">Cancel</button>
                <button class="btn new-save-button ml-2 mr-2"
                    @click="saveProduct()">Save</button>
            </div>
            <div v-else class="v-modal-footer m-auto p-4" style="position: relative;">
                <button class="btn btn-des-small ml-2 mr-2"
                    style="color: #d51650; border: 1px solid transparent; background: #fff;" disabled>Cancel</button>
                <button class="btn btn-des-small ml-2 mr-2"
                    style="color: #fff; background: #008a63; border: 1px solid transparent" disabled>Save</button>
                    <hollow-dots-spinner v-if="disableButtonAndDisplayLoader == true" style="position: absolute;margin: 0;top: 36px;display: flex;justify-content: center;width: 145% !important;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
            </div>
        </div>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
        <success-message v-if="success_product" :message="message" modal_name="success-message"
            @hideSuccess="hideSuccess"></success-message>
    </modal>
</template>

<script>
    import { HollowDotsSpinner } from "epic-spinners";
    const SuccessMessage = () => import("../SuccessMessage");
    import products from '../mixins/products';
    import myUpload from 'vue-image-crop-upload'
    import UploadPicture from "../UploadPicture"
    import {
        HalfCircleSpinner
    } from "epic-spinners";
    import {
        SweetModal
    } from 'sweet-modal-vue';
    export default ({
        props: ["modal_name"],
        data() {
            return {
                disableButtonAndDisplayLoader: false,
                is_star:"false",
                starDetails:"",
                product_name: "",
                product_description: "",
                imgDataUrl: 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/newcrm/logo.svg', // the datebase64 url of created image,
                product_pic: '',
                showProfilePic: false,
                ajaxCallInProgress: false,
                headers: {
                    smail: '*_~'
                },
                param: {
                    token: '123456798',
                    name: 'avatar'
                },
                editPro: false,
                success_msg: '',
                warning_msg: '',
                success_product: false,
                message: '',
                img_loader: false
            }
        },
        mixins: [products],
        components: {
            products,
            myUpload,
            SweetModal,
            SuccessMessage,
            HalfCircleSpinner,
            HollowDotsSpinner,
            UploadPicture
        },
        methods: {
            //It's show starred and notstarred based on the conditions
            /**@params data*/
            starData(data){
                if(data == true){
                    this.starDetails = "Starred"
                } else {
                    this.starDetails = "Not Starred"
                }
            },
            //Upload image data, using to upload the images in the cloud
            /**@params imgData */
            uploadImage (imgData) {
                this.product_pic = imgData
                this.img_loader = false
            },
            //Hide Add product Modal
            hideAddProductModal() {
                this.$emit("hide-add-product-modal")
            },
            //Hide Product Add Success Modal
            hideSuccess() {
                this.success_product = false;
                this.hideAddProductModal()
                this.$emit("createProducts")
            },
            //API call to save the product
            saveProduct() {
                this.$validator.validateAll().then(async result => {
                    if (result) {
                        try{
                            this.disableButtonAndDisplayLoader = true;
                            let response = await this.createProducts(this.add_product) /** @params =this.add_product*/
                            this.success_product = true;
                            this.message = "Product Created Successfully"
                            setTimeout(() => {
                                this.disableButtonAndDisplayLoader = false;
                                this.$modal.show('success-message');
                            }, 1000);
                        } catch(error) {
                            this.warning_msg = error
                            this.$refs.warning_modal.open();
                            setTimeout(() => {
                                this.disableButtonAndDisplayLoader = false;
                                this.$refs.warning_modal.close();
                            }, 3000);
                        }
                    }
                });
            },
            CallLoader(){
                this.img_loader = true
            }
        },
        computed: {
            //Adding the all fields to pass as params while saving the product
            add_product() {
                return {
                    logo: this.product_pic,
                    name: this.product_name,
                    description: this.product_description,
                    is_star:this.is_star
                }
            }
        },
        mounted(){
            //Initially checking the condtion for stared and not starred
            this.is_star = false
            if(this.is_star == true){
                this.starDetails = "Starred"
            } else {
                this.starDetails = "Not Starred"
            }
        }
    })
</script>

<style scoped>
    .digi-textarea.text-width {
        width: 95% !important
    }
    .star {
        visibility:hidden;
        font-size:30px;
        cursor:pointer;
    }
    .star:checked:before {
        content: "\2605";
        position: absolute;
        color: rgb(255, 154, 6);
        visibility:visible;
    }
    .star:before {
        content: "\2606";
        position: absolute;
        visibility:visible;
        color: #000;
    }
</style>


// WEBPACK FOOTER //
// src/components/products/AddProduct.vue